(() => {
  'use strict';

  const selector = '[data-ilb-reader]';

  function initializeReader(reader) {
    if (reader.hasAttribute('data-ilb-reader-ready')) return;

    const image = reader.querySelector('#ILBReaderImage');
    const caption = reader.querySelector('[data-reader-caption]');
    const heading = reader.querySelector('[data-reader-heading]');
    const description = reader.querySelector('[data-reader-description]');
    const buttons = Array.from(reader.querySelectorAll('button[data-pattern]'));
    if (!image || !caption || !heading || !description || !buttons.length) return;

    reader.setAttribute('data-ilb-reader-ready', '');
    let request = 0;
    const selected = buttons.find(button => button.getAttribute('aria-pressed') === 'true') || buttons[0];
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const { image: source, imageAlt, heading: nextHeading, description: nextDescription } = button.dataset;
        if (!source || !imageAlt || !nextHeading || !nextDescription) return;

        const currentRequest = ++request;
        if (button.getAttribute('aria-pressed') === 'true') {
          reader.removeAttribute('aria-busy');
          return;
        }

        // Keep the current illustration and copy together until the next image is ready.
        const nextImage = new Image();
        reader.setAttribute('aria-busy', 'true');
        nextImage.onload = () => {
          if (currentRequest !== request || !reader.isConnected) return;

          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
          image.alt = imageAlt;
          const label = button.querySelector('span:not([aria-hidden="true"])');
          caption.textContent = label ? label.textContent.trim() : button.textContent.trim();
          heading.textContent = nextHeading;
          description.textContent = nextDescription;
          buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          reader.removeAttribute('aria-busy');
        };
        nextImage.onerror = () => {
          if (currentRequest === request) reader.removeAttribute('aria-busy');
        };
        nextImage.src = source;
      });
    });
  }

  function initialize(root) {
    if (root.matches && root.matches(selector)) initializeReader(root);
    root.querySelectorAll(selector).forEach(initializeReader);
  }

  initialize(document);

  // Shopify can replace sections without reloading the page. Bind this listener once,
  // even if the theme editor evaluates this asset again after a section update.
  if (!document.documentElement.hasAttribute('data-ilb-reader-listener')) {
    document.documentElement.setAttribute('data-ilb-reader-listener', '');
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
